export default {
  auth: {
    session_id: "/auth/school/token/",
    login: "/auth/token/",
    refresh: "/auth/token/refresh/",
  },
  school: {
    admins: {
      cards: {
        all: "/school/admins/cards/",
        blocked: "/school/admins/cards/blocked/",
        one: "/school/admins/cards/$id/",
        events: "/school/admins/cards/events/",
        deleted: "/school/admins/cards/deleted/",
      },
      external_cards: {
        all: "/school/admins/external/cards/",
        one: "/school/admins/external/cards/$id/",
        decline: "/school/admins/external/cards/$id/decline/",
      },
      suggestions: {
        classes: "/school/admins/suggestions/classes/",
        users: "/school/admins/suggestions/users/",
        schools: "/school/admins/suggestions/schools/",
      },
      teachers: {
        all: "/school/admins/teachers/",
        one: "/school/admins/teachers/$id/",
        passages: "/school/admins/teachers/passages/",
      },
      students: {
        all: "/school/admins/students/",
        one: "/school/admins/students/$id/",
        parent: "/school/admins/students/$id/$parent_id/",
        passages: "/school/admins/students/passages/",
      },
      guests: {
        passages: "/school/admins/guests/passages/",
      },
      payer: {
        info: "/school/admins/payer/$parent_id/$pupil_id/",
        tariffs: "/school/admins/payer/tariffs/$parent_id/$pupil_id/",
        setCurrent:
          "/school/admins/payer/tariffs/set/current/$parent_id/$pupil_id/$tariff_id/",
        resumeCurrent:
          "/school/admins/payer/tariffs/current/$parent_id/$pupil_id/",
        pauseCurrent:
          "/school/admins/payer/tariffs/current/pause/$parent_id/$pupil_id/",
        updateCurrent:
          "/school/admins/payer/tariffs/current/update/$parent_id/$pupil_id/",
      },
      presence: "/school/admins/presence/list/",
      statistics: "/school/admins/presence/statistics/",
      notifications: {
        self: "/school/admins/notifications/",
        other: "/school/admins/other/notifications/",
        read: "/school/admins/notifications/$id/",
      },
      reports: {
        issued_cards: "/school/admins/reports/generate/issued_cards/",
        blocked_cards: "/school/admins/reports/generate/blocked_cards/",
        passages: "/school/admins/reports/generate/passages/",
        extended_cards: "/school/admins/reports/generate/extended_cards/",
        denied_passages: "/school/admins/reports/generate/denied_passages/",
        presence: "/school/admins/reports/generate/presence/",
        status: "/school/admins/reports/status/$guid/",
        download: "/school/admins/reports/download/$guid/",
      },
    },
  },
  parent: {
    support: {
      message: "/parent/support/$person_id/",
      contacts: "/parent/support/contacts/",
    },
    cards: {
      all: "/parent/cards/",
      one: "/parent/cards/$id/",
    },
    students: {
      all: "/parent/students/",
      one: "/parent/students/$person_id/",
    },
    payer: {
      info: "/parent/payer/$person_id/",
      tariffs: "/parent/payer/tariffs/$person_id/",
      setCurrent: "/parent/payer/tariffs/set/current/$person_id/$id/",
      setNext: "/parent/payer/tariffs/set/next/$person_id/$id/",
      pause: "/parent/payer/tariffs/current/pause/$person_id/",
      unpause: "/parent/payer/tariffs/current/unpause/$person_id/",
    },
    payments: {
      create: "/parent/payments/create/$person_id/$amount/",
    },
    notifications: {
      all: "/parent/notifications/$person_id/",
      settings: "/parent/notifications/settings/$person_id/",
      read: "/parent/notifications/$person_id/$id/",
    },
    balance: {
      history: "/parent/balance/history/$person_id/",
    },
    passages: {
      all: "/parent/passages/$person_id/",
    },
    agreement: {
      current: "/parent/agreement/",
    },
    reports: {
      passages: "/parent/reports/generate/passages/$person_id/",
      balance_history: "/parent/reports/generate/balance_history/$person_id/",
      status: "/parent/reports/status/$guid/",
      download: "/parent/reports/download/$guid/",
    },
  },
  teacher: {
    notifications: {
      all: "/teacher/notifications/",
      one: "/teacher/notifications/$id/",
    },
    passages: "/teacher/passages/",
    suggestions: {
      classes: "/teacher/suggestions/classes/",
    },
    cards: {
      all: "/teacher/cards/",
      one: "/teacher/cards/$id/",
      events: "/teacher/cards/events/",
    },
    students: {
      all: "/teacher/students/",
      parent: "/teacher/students/$id/$parent_id/",
    },
    reports: {
      issued_cards: "/teacher/reports/generate/issued_cards/",
      blocked_cards: "/teacher/reports/generate/blocked_cards/",
      passages: "/teacher/reports/generate/passages/",
      extended_cards: "/teacher/reports/generate/extended_cards/",
      denied_passages: "/teacher/reports/generate/denied_passages/",
      presence: "/teacher/reports/generate/presence/",
      status: "/teacher/reports/status/$guid/",
      download: "/teacher/reports/download/$guid/",
    },
  },
  department: {
    passages: "/department/passages/",
    suggestions: {
      municipalities: "/department/suggestions/districts/",
      schools: "/department/suggestions/schools/",
      classes: "/department/suggestions/schools/classes/",
    },
    cards: {
      all: "/department/cards/",
      blocked: "/department/cards/blocked/",
      events: "/department/cards/events/",
      deleted: "/department/cards/deleted/",
    },
    reports: {
      issued_cards: "/department/reports/generate/issued_cards/",
      blocked_cards: "/department/reports/generate/blocked_cards/",
      passages: "/department/reports/generate/passages/",
      extended_cards: "/department/reports/generate/extended_cards/",
      denied_passages: "/department/reports/generate/denied_passages/",
      presence: "/department/reports/generate/presence/",
      status: "/department/reports/status/$guid/",
      download: "/department/reports/download/$guid/",
    },
  },
  municipality: {
    passages: "/municipality/passages/",
    suggestions: {
      schools: "/municipality/suggestions/schools/",
      classes: "/municipality/suggestions/schools/classes/",
    },
    cards: {
      all: "/municipality/cards/",
      blocked: "/municipality/cards/blocked/",
      events: "/municipality/cards/events/",
      deleted: "/municipality/cards/deleted/",
    },
    reports: {
      issued_cards: "/municipality/reports/generate/issued_cards/",
      blocked_cards: "/municipality/reports/generate/blocked_cards/",
      passages: "/municipality/reports/generate/passages/",
      extended_cards: "/municipality/reports/generate/extended_cards/",
      denied_passages: "/municipality/reports/generate/denied_passages/",
      presence: "/municipality/reports/generate/presence/",
      status: "/municipality/reports/status/$guid/",
      download: "/municipality/reports/download/$guid/",
    },
  },
  superadmin: {
    tariffs: {
      all: "/superadmin/tariffs/",
      archived: "/superadmin/tariffs/archived/",
      one: "/superadmin/tariffs/$id/",
      school: "/superadmin/tariffs/$id/school/$unit_id/",
      pause: "/superadmin/tariffs/$id/pause/",
      resume: "/superadmin/tariffs/$id/reactivate/",
      replace: {
        new: "/superadmin/tariffs/$id/$new_id/",
        list: "/superadmin/tariffs/replacements/",
      },
      massExtend: {
        new: "/superadmin/payer/tariffs/mass_offset/",
        list: "/superadmin/payer/tariffs/list/mass_offset/",
      },
      massPause: {
        new: "/superadmin/payer/tariffs/mass_pause/",
        list: "/superadmin/payer/tariffs/list/mass_pause/",
      },
      massResume: {
        new: "/superadmin/payer/tariffs/mass_unpause/",
        list: "/superadmin/payer/tariffs/list/mass_unpause/",
      },
      massAssign: "/superadmin/tariffs/$id/mass_assign/",
    },
    suggestions: {
      municipalities: "/superadmin/suggestions/districts/",
      schools: "/superadmin/suggestions/schools/",
      classes: "/superadmin/suggestions/districts/classes/",
      users: "/superadmin/suggestions/users/",
    },
    users: {
      reauth: "/superadmin/reauth/$user_id/",
      teachers: "/superadmin/teachers/",
      students: "/superadmin/students/",
      parent: "/superadmin/students/$id/$parent_id/",
    },
    operators: {
      all: "/superadmin/operators/",
      one: "/superadmin/operators/$id/",
      token: "/superadmin/operators/$id/replace_token/",
      setLastFullUpdate: "/superadmin/operators/$id/set_last_full_update/",
      disconnects: "/superadmin/operators/connections/lost/",
    },
    syncTasks: {
      all: "/sync/tasks/",
      one: "/sync/tasks/$id/",
      units: "/sync/tasks/units/",
      revoke: "/sync/tasks/revoke/",
      status: "/sync/tasks/status/",
    },
    apiKeys: {
      all: "/superadmin/external/clients/",
      one: "/superadmin/external/clients/$id/",
    },
    agreements: {
      all: "/superadmin/agreements/",
      one: "/superadmin/agreements/$id/",
      current: "/superadmin/agreements/active/",
    },
    stat: {
      global: "/superadmin/presence/statistics/global/",
      municipality: "/superadmin/presence/statistics/districts/",
      schools: "/superadmin/presence/statistics/schools/",
    },
    passages: {
      all: "/superadmin/passages/",
      withoutCard: "/superadmin/students/$id/without-card/",
    },
    cards: {
      all: "/superadmin/cards/",
      blocked: "/superadmin/cards/blocked/",
      one: "/superadmin/cards/$id/",
      events: "/superadmin/cards/events/",
      deleted: "/superadmin/cards/deleted/",
      upload: {
        pupils: "/superadmin/cards/upload/pupils/",
        teachers: "/superadmin/cards/upload/teachers/",
      },
    },
    payer: {
      info: "/superadmin/payer/$parent_id/$pupil_id/",
      tariffs: "/superadmin/payer/tariffs/$parent_id/$pupil_id/",
      setCurrent:
        "/superadmin/payer/tariffs/set/current/$parent_id/$pupil_id/$tariff_id/",
      resumeCurrent: "/superadmin/payer/tariffs/current/$parent_id/$pupil_id/",
      pauseCurrent:
        "/superadmin/payer/tariffs/current/pause/$parent_id/$pupil_id/",
      updateCurrent:
        "/superadmin/payer/tariffs/current/update/$parent_id/$pupil_id/",
      refill: "/superadmin/payments/manual/$parent_id/$pupil_id/",
    },
    notifications: {
      other: "/superadmin/other/notifications/",
      massTemplates: "/superadmin/notifications/global/templates/",
      massTemplate: "/superadmin/notifications/global/templates/$id/",
      sendToAll: "/superadmin/notifications/global/to_all/",
      sendToSchool: "/superadmin/notifications/global/to_unit/",
      sendToParent: "/superadmin/notifications/global/to_user/",
    },
    supportRequests: {
      all: "/superadmin/support/requests/",
      read: "/superadmin/support/requests/$id/",
    },
    support: {
      contacts: {
        all: "superadmin/support/contacts/",
        one: "superadmin/support/contacts/$id/",
      },
    },
    settings: {
      software_version: "superadmin/settings/software_version/",
      tariff_pause_days: "superadmin/settings/tariff_pause_days",
      operator_settings: "superadmin/settings/operator_settings",
    },
    templates: {
      all: "/superadmin/templates/",
      one: "/superadmin/templates/$id/",
      assignments: "/superadmin/templates/$id/assignments/",
      assign: "/superadmin/templates/$id/assignment/$role/$channel/",
    },
    reports: {
      lost_connections: "/superadmin/reports/generate/lost_connections/",
      sent_sms: "/superadmin/reports/generate/sent_sms/",
      all_notifications: "/superadmin/reports/generate/all_notifications/",
      issued_cards: "/superadmin/reports/generate/issued_cards/",
      blocked_cards: "/superadmin/reports/generate/blocked_cards/",
      passages: "/superadmin/reports/generate/passages/",
      statistics: "/superadmin/reports/generate/statistics/",
      status: "/superadmin/reports/status/$guid/",
      download: "/superadmin/reports/download/$guid/",
    },
    devices: {
      all: "/superadmin/devices/",
    },
  },
  constants: "/common/constants/",
  reports: "/common/reports/",
};
